<template>
  <z-expansion-config-item 
    :titulo="configuracao.descricao" 
    :subtitulo="configuracao.ajuda"
  >
    <v-switch
      v-model="store.configuracoes.APP_ALTERAR_REF_PROD"
      :label="label"
      left
      hide-details
      class="mt-0 pt-0 switch-reverse"
      @change="updateConfig"
    ></v-switch>
  </z-expansion-config-item>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'

const store = useConfigStore();

const { proxy } = getCurrentInstance();

const configuracao = {
  config: 'APP_ALTERAR_REF_PROD',
  valor: store.configuracoes.APP_ALTERAR_REF_PROD,
  tipo: 'boolean',
  descricao: 'Alterar referência do produto',
  ajuda: 'Ativa ou desativa a alterarção da referência do produto no cadastro'
}

async function updateConfig() {
  configuracao.valor = store.configuracoes.APP_ALTERAR_REF_PROD;
  await store.salvarConfiguracao(configuracao);
  proxy.$store.dispatch("carregarConfiguracoes");
}

const label = computed(() => {
  return store.configuracoes.APP_ALTERAR_REF_PROD ? 'Ativado' : 'Desativado';
})

</script>

1<style lang="scss" scoped>

.switch-reverse :deep(.v-input__slot) {
  flex-direction: row-reverse;

  label {
    width: 100px;
  }
}

</style>
